import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    number: '1',
    title: 'Identificas el nudo',
    description: 'Usas las plantillas para ver dónde se detuvo el flujo de amor en tu árbol.'
  }, {
    number: '2',
    title: 'Ordenas tu lugar',
    description: 'Realizas los ejercicios para dejar de cargar con tus padres y ser "la pequeña" que puede recibir.'
  }, {
    number: '3',
    title: 'Abres el espacio',
    description: 'Usas los audios y rituales de fe para dar el "SÍ" definitivo a la vida en tu hogar y tu cuerpo.'
  }];
  return <section ref={ref} className="w-full bg-cream py-6 md:py-10 px-6" data-id="element-140">
      <div className="max-w-4xl mx-auto" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-142">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brown mb-8 text-center" data-id="element-143">
            Cómo Funciona
          </h2>

          <div className="space-y-5" data-id="element-144">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex gap-6 items-start" data-id="element-145">
                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-gradient-to-br from-rose to-gold flex items-center justify-center shadow-lg" data-id="element-146">
                  <span className="font-serif text-2xl font-bold text-white" data-id="element-147">
                    {step.number}
                  </span>
                </div>
                <div className="flex-1 bg-white rounded-2xl p-5 shadow-sm border border-rose/10" data-id="element-148">
                  <h3 className="font-serif text-xl md:text-2xl font-bold text-brown mb-2" data-id="element-149">
                    {step.title}
                  </h3>
                  <p className="font-sans text-base md:text-lg text-brown/80 leading-relaxed" data-id="element-150">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}